import { render, staticRenderFns } from "./ListReceiver.vue?vue&type=template&id=7a5fa580&scoped=true"
import script from "./ListReceiver.vue?vue&type=script&lang=js"
export * from "./ListReceiver.vue?vue&type=script&lang=js"
import style0 from "./ListReceiver.vue?vue&type=style&index=0&id=7a5fa580&lang=css"
import style1 from "./ListReceiver.vue?vue&type=style&index=1&id=7a5fa580&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5fa580",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a5fa580')) {
      api.createRecord('7a5fa580', component.options)
    } else {
      api.reload('7a5fa580', component.options)
    }
    module.hot.accept("./ListReceiver.vue?vue&type=template&id=7a5fa580&scoped=true", function () {
      api.rerender('7a5fa580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/notify/ListReceiver.vue"
export default component.exports